import { createFileRoute, redirect } from "@tanstack/react-router";
import { LandingTemplate } from "~/features/landing/LandingTemplate";
import { useAuthStore } from "~/stores/useAuthStore";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    const token = useAuthStore.getState().token;
    if (token) {
      throw redirect({ to: "/discover" });
    }
  },
  component: LandingTemplate,
});
